<template>
	<div class="flex gap-1 items-center">
		<div
			:class="[`w-3 h-3 flex ${colorOfCircle} rounded-full !opacity-100`]"
		></div>
		<p class="text-sm font-medium">
			<span v-if="stockStatus?.stockStatusText">
				{{ stockStatus.stockStatusText }}
			</span>
			<span v-else class="capitalize">
				{{ $t("in stock") }}
			</span>
		</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { StockStatusItem } from "~/types/storyblok/storyblok";

interface Props {
	stockStatus: StockStatusItem | null;
}

const { stockStatus } = defineProps<Props>();

const colorOfCircle = computed(() => stockStatus?.buttonColor || "bg-success");
</script>
